export type SignUpStyleProps = {
  background?: string
}

export enum Sex {
  MALE = 1,
  FEMALE = 2
}
